
import { Vue, Component, Ref, Prop, Watch } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';


@Component
export default class VehicleSourceProcedureInformationField extends Vue {
  @Ref()
  childFormRef!: FormModel;

  labelCol = { span: 10 };
  wrapperCol = { span: 10 };

  formModel: any = {
    certificateInfo: undefined,
    purchaseInvoice: undefined,
    maintenanceInfo: undefined,
  };

  certificateInfoOptions: any = [];

  purchaseInvoiceOptions: any = [
    { value: 1, label: '有' },
    { value: 2, label: '无' },
  ];

  maintenanceInfoOptions: any = [];

  rules = {
    certificateInfo: [{ required: true, message: '请选择登记证' }],
    purchaseInvoice: [{ required: true, message: '请选择购车发票' }],
    maintenanceInfo: [{ required: true, message: '请选择保养记录' }],
  };


  @Prop()
  value!: any;


  @Prop()
  readonly!: boolean;

  @Watch('formModel.certificateInfo')
  certificateInfo() {
    this.handleFormModelChange();
  }

  @Watch('formModel.purchaseInvoice')
  purchaseInvoice() {
    this.handleFormModelChange();
  }

  @Watch('formModel.maintenanceInfo')
  maintenanceInfo() {
    this.handleFormModelChange();
  }

  getLabel(arr: any, val: any) {
    let _text = '';
    arr.forEach((res: any) => {
      if (res.value === val) {
        _text = res.label;
      }
    });
    return _text;
  }


  handleFormModelChange() {
    this.$emit('update', this.formModel);
  }

  @Watch('value')
  handleValueChange() {
    const { certificateInfo, purchaseInvoice, maintenanceInfo } = this.value;
    this.formModel = {
      certificateInfo: certificateInfo != null ? Number(certificateInfo) : undefined,
      purchaseInvoice: purchaseInvoice != null ? Number(purchaseInvoice) : undefined,
      maintenanceInfo: maintenanceInfo != null ? Number(maintenanceInfo) : undefined,
    };
  }

  breakDown(val: any) {
    const _a = [];
    for (const key in val) {
      if (key) {
        _a.push({
          value: Number(key),
          label: val[key],
        });
      }
    }
    return _a;
  }
  mounted() {
    this.handleValueChange();
    const carFields = JSON.parse(localStorage.getItem('carFields') || '{}');
    const { certificate_info, maintenance_info } = carFields;
    this.certificateInfoOptions = this.breakDown(certificate_info);
    // this.purchaseInvoiceOptions = this.breakDown();
    this.maintenanceInfoOptions = this.breakDown(maintenance_info);
  }

  public async validateFields(): Promise<boolean> {
    try {
      const valid = await (this.childFormRef as any).validate();
      return valid;
    } catch (error) {
      // console.error('子表单校验失败:', error);
      return false;
    }
  }
}

